import React from "react";

const Moon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.35294 3C5.84895 4.40815 3 7.46295 3 11.4706C3 16.7335 7.26646 21 12.5294 21C16.537 21 19.5918 18.1511 21 14.6471C8.1706 17.0647 8.13973 8.13973 9.35294 3Z"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Moon;
